import Vue, { VueConstructor } from 'vue'
import {
  configure,
  extend,
  localize,
  ValidationObserver,
  ValidationProvider,
} from 'vee-validate'
import {
  between,
  confirmed,
  email,
  max,
  max_value as maxValue,
  min_value as minValue,
  min,
  numeric,
  length,
  regex,
  required,
  required_if as requiredIf,
} from 'vee-validate/dist/rules'
import ja from 'vee-validate/dist/locale/ja.json'
import i18n from '@/config/i18n'
import TelNumber from './validations/TelValidator'
import Zip from './validations/ZipValidator'
import Kana from './validations/KanaValidator'
import Password from './validations/PasswordValidator'
import Float from '@/plugins/validations/FloatValidator'
import Yamato from '@/plugins/validations/YamatoValidator'
import BankAccount from '@/plugins/validations/BankAccountValidator'

export function setupValidation(vue: VueConstructor<Vue>): void {
  vue.component('ValidationProvider', ValidationProvider)
  vue.component('ValidationObserver', ValidationObserver)

  localize('ja', ja)
  extend('email', email)
  extend('max', max)
  extend('min', min)
  extend('max_value', maxValue)
  extend('min_value', minValue)
  extend('numeric', numeric)
  extend('float', Float)
  extend('between', between)
  extend('required', required)
  extend('required_if', requiredIf)
  extend('confirmed', confirmed)
  extend('length', length)
  extend('regex', regex)
  extend('tel', TelNumber)
  extend('zip', Zip)
  extend('kana', Kana)
  extend('password', Password)
  extend('yamato', Yamato)
  extend('bankAccount', BankAccount)
}

setupValidation(Vue)

configure({
  defaultMessage: (field, values) => {
    values._field_ = i18n.t(`${field}`)
    return i18n.tc(`validations.${values._rule_}`, 1, values)
  },
  // see: https://vee-validate.logaretm.com/v3/configuration.html#config
  useConstraintAttrs: false,
})
